import { render, staticRenderFns } from "./warrantyInfo.vue?vue&type=template&id=a054ce64&scoped=true&"
import script from "./warrantyInfo.vue?vue&type=script&lang=js&"
export * from "./warrantyInfo.vue?vue&type=script&lang=js&"
import style0 from "./warrantyInfo.vue?vue&type=style&index=0&id=a054ce64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a054ce64",
  null
  
)

export default component.exports